import { InputLabel, TextField } from '@mui/material';
import { EditInstallerForm } from 'components/Drawer/types';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { MobileType } from 'state/types';
import AlertStatus from 'ui/atoms/AlertStatus/AlertStatus';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface Props {
  register: UseFormRegister<EditInstallerForm>;
  nameInputValue: string;
  handleNameInputOnChange: (value: string) => void;
  nameInputValidation: string | undefined;
  emailInputValue: string;
  statusAccess: boolean;
  statusConfig: boolean;
  showValidation: boolean;
  isEditable?: boolean;
  isResendInvitationButtonVisibleConfig: boolean;
  isResendInvitationButtonVisibleAccess: boolean;
  handleOnResendInvitationClick: (type: MobileType) => void;
}

const EditInstaller: React.FC<React.PropsWithChildren<Props>> = ({
  register,
  nameInputValue,
  emailInputValue,
  handleNameInputOnChange,
  nameInputValidation,
  statusAccess,
  statusConfig,
  showValidation,
  isEditable,
  isResendInvitationButtonVisibleConfig,
  isResendInvitationButtonVisibleAccess,
  handleOnResendInvitationClick
}) => {
  const { translation } = useTranslation();

  return (
    <ComponentWrapper flexDirection="column" gap="1.5rem" margin="0.5rem 0 0 0">
      <TextField
        {...register('name')}
        onChange={(event) => (isEditable ? handleNameInputOnChange(event.target.value) : undefined)}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        size="medium"
        disabled={!isEditable}
        label={translation.name}
        value={nameInputValue}
        id="drawer-input-name"
        error={showValidation && nameInputValidation !== undefined}
        helperText={showValidation ? nameInputValidation : undefined}
      />
      <TextField
        {...register('email')}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        size="medium"
        label={translation.e_mail}
        value={emailInputValue}
        id="drawer-input-email"
        disabled
      />
      <ComponentWrapper flexDirection="column" gap="1.5rem">
        <ComponentWrapper flexDirection="column">
          <InputLabel variant="outlined" shrink>
            {translation.atlas_access_app}
          </InputLabel>
          <AlertStatus
            id="access-app-status"
            isConnected={statusAccess}
            buttonText={statusAccess ? '' : translation.resend_invitation}
            onClick={isResendInvitationButtonVisibleAccess ? () => handleOnResendInvitationClick('ACCESS') : undefined}
          />
        </ComponentWrapper>
        <ComponentWrapper flexDirection="column">
          <InputLabel variant="outlined" shrink>
            {translation.atlas_config_app}
          </InputLabel>
          <AlertStatus
            id="config-app-status"
            isConnected={statusConfig}
            buttonText={statusConfig ? '' : translation.resend_invitation}
            onClick={isResendInvitationButtonVisibleConfig ? () => handleOnResendInvitationClick('CONFIG') : undefined}
          />
        </ComponentWrapper>
      </ComponentWrapper>
    </ComponentWrapper>
  );
};

export default EditInstaller;
